export default __webpack_public_path__ + "static/media/gebiss.4679cda9.jpg";